import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { Form, Input, Button, Checkbox, Card, Row, Col, notification, } from 'antd';
import ajaxService from '../../services/ajax-services';
import { CheckCircleOutlined, CloseCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { useWindowSize } from '../../hooks';


const Login = () => {


    const { width } = useWindowSize()


    const isMobile = width <= 768
    let history = useHistory();
    let location = useLocation();
    const [captchaImg, setCaptchaImg] = useState('');
    const [captchaKey, setCaptchaKey] = useState('');

    let { from } = location.state || { from: { pathname: "/" } };


    const loadCaptcha = async () => {
        const data = await ajaxService.getCaptcha();
        if (data) {
            setCaptchaImg(data.captcha);
            setCaptchaKey(data.key);
        }
    };

    useEffect(() => {
        loadCaptcha();
    }, []);

    const onFinish = async (values) => {
        try {


            const response = await ajaxService.getAccessToken({
                username: values.email,
                password: values.password,
                captcha: values.captcha,
                captcha_key: captchaKey,
            });


            if (response.errors || response.message) {
                const errorMessage = response.errors || response.message || 'Something went wrong';
                notification.error({
                    message: 'Login Failed',
                    description: errorMessage,
                    icon: <CloseCircleOutlined style={{ color: 'red' }} />,
                });
                loadCaptcha();
                return;
            }
            // if (response.message) {
            //     notification.open({
            //         message: response.message,
            //         icon: <CloseCircleOutlined style={{ color: 'red' }} />
            //     });
            //     return;
            // }
            if (!response.data || !response.data.token || !response.data.user) {
                notification.open({
                    message: "Something went wrong. Please try again.",
                    icon: <CloseCircleOutlined style={{ color: 'red' }} />
                });
                return;
            }

            const { token, user } = response.data;
            const { verified, id } = user;

            if (verified) {
                localStorage.setItem('token', token);
                localStorage.setItem('loggedInUser', id);
                localStorage.setItem('user', JSON.stringify(user));
                history.replace(from);
            } else {
                history.replace({ pathname: "/pandingAproval", search: '?via=login' });
            }
        } catch (error) {

            let errorMessage = "Something went wrong. Please try again.";
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }
            loadCaptcha();

            notification.open({
                message: errorMessage,
                icon: <CloseCircleOutlined style={{ color: 'red' }} />
            });
        }
    };




    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    useEffect(() => {
        if (location.search === '?via=password-reset') {
            notification.open({ message: 'Your password has been changed', icon: <CheckCircleOutlined style={{ color: '#108ee9' }} /> })
        }
    }, [])


    const CaptchaInput = () => (
        <Form.Item label="CAPTCHA" required>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                <img src={captchaImg} alt="captcha" style={{ marginRight: 10 }} />
                <Button onClick={loadCaptcha}>Reload</Button>
            </div>
            <Form.Item name="captcha" rules={[{ required: true, message: 'Enter CAPTCHA' }]} noStyle>
                <Input placeholder="Enter CAPTCHA" />
            </Form.Item>
        </Form.Item>
    );

    const renderLogin = () => {
        return (
            <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '70px', marginBottom: '70px' }} >
                <Col span={3}></Col>
                <Col span={18}>
                    <Row>
                        <Col span={8}>

                        </Col>
                        <Col span={8}>
                            <Card title="Sign in to your account" variant="outlined" style={{ width: '100%' }}
                                actions={[
                                    <a style={{ color: '#4687F2' }} onClick={() => history.push({ pathname: '/register' })}>Register here</a>
                                ]}>
                                <Form
                                    //{...layout}
                                    layout={'vertical'}
                                    name="basic"
                                    initialValues={{
                                        remember: true,
                                    }}
                                    onFinish={onFinish}
                                    onFinishFailed={onFinishFailed}>
                                    <Form.Item
                                        label="Email"
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Email is required',
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        label="Password"
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                min: 8,
                                                message: "Password must be at least 8 characters",
                                            },
                                        ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>

                                    <CaptchaInput />

                                    <a onClick={() => history.push({ pathname: '/forgotPassword' })}>Forgot Password?</a>
                                    <Button style={{ marginLeft: 35 }} type="primary" htmlType="submit">
                                        Submit
                                    </Button>

                                </Form>
                                <center>

                                </center>
                            </Card>
                        </Col>
                        <Col span={8}>

                        </Col>
                    </Row>

                </Col>
                <Col span={3}></Col>
            </Row>
        );
    }

    const renderLoginMobile = () => {
        return (
            <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '70px', marginBottom: '70px' }} >


                <Col span={24}>
                    <Card title="Sign in to your account" variant="outlined" style={{ width: '100%' }}
                        actions={[
                            <a style={{ color: '#4687F2' }} onClick={() => history.push({ pathname: '/register' })}>Register here</a>
                        ]}>
                        <Form
                            //{...layout}
                            layout={'vertical'}
                            name="basic"
                            initialValues={{
                                remember: true,
                            }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Email is required',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        min: 8,
                                        message: "Password must be at least 8 characters",
                                    },
                                ]}
                            >
                                <Input.Password />
                            </Form.Item>

                            <CaptchaInput />

                            <a onClick={() => history.push({ pathname: '/forgotPassword' })}>Forgot Password?</a>
                            <Button style={{ marginLeft: 40 }} type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form>
                    </Card>
                </Col>
            </Row>
        )
    }

    const renderContent = () => {
        if (isMobile) {
            return renderLoginMobile()
        } else {
            return renderLogin()
        }
    }

    return (
        <>
            {renderContent()}
        </>
    )
}

export default Login